import { DeviceItem, useLocaleStore } from '@/stores'
import { computed, ref } from 'vue'
import { BaseScreenCapability } from '@rapoo/device-sdk'

export function useScreenDisplay(itemRef: { value: DeviceItem }) {
  const { t } = useLocaleStore()
  const device = computed(() => itemRef.value.original)

  const isImgScreen = computed(() => {
    const baseScreen = device.value.manifest.capabilities.find(
      (c): c is BaseScreenCapability => c.type === 'baseScreen',
    )
    if (!baseScreen) return false
    return baseScreen.config.screenType === 'screen'
  })

  const brightness = ref<null | number>(null)
  const initBrightness = async () => {
    const baseScreen = device.value.features.baseScreen
    if (baseScreen) {
      brightness.value = await baseScreen.getScreenBrightness()
    }
  }

  const imgNumber = ref<null | number>(null)
  const initImgNumber = async () => {
    const baseScreen = device.value.features.baseScreen
    if (baseScreen) {
      const { imageNum } = await baseScreen.getImageOrder()
      imgNumber.value = imageNum
    }
  }

  const initScreenDisplay = async () => {
    if (!isImgScreen.value) return
    await initBrightness()
    await initImgNumber()
  }

  const screenDisplayData = computed(() => {
    if (device.value.manifest.type !== 'base') {
      return null
    }
    if (!isImgScreen.value) {
      return null
    }
    const data = []

    if (brightness.value !== null) {
      // 屏幕亮度
      data.push({
        name: t('home.overview.screenDisplay.brightness'),
        value: `${brightness.value}%`,
      })
    }
    if (imgNumber.value !== null) {
      // 屏显图片数量
      data.push({
        name: t('home.overview.screenDisplay.imageCount'),
        value: `${imgNumber.value}${t('home.overview.screenDisplay.imageUnit')}`,
      })
    }

    if (!data.length) return null

    return {
      title: t('home.overview.screenDisplay.title'),
      data,
    }
  })

  return {
    screenDisplayData,
    initScreenDisplay,
  }
}
